import { render, staticRenderFns } from "./BreedTreeSelect.vue?vue&type=template&id=7049985a&scoped=true"
import script from "./BreedTreeSelect.vue?vue&type=script&lang=js"
export * from "./BreedTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./BreedTreeSelect.vue?vue&type=style&index=0&id=7049985a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7049985a",
  null
  
)

export default component.exports